import { ENV } from "./env";

export interface ManualEntry {
  /** URL slug used in route /manuals/:slug */
  slug: string;
  /** i18n key under manuals.items (e.g. "qlcv" → t("manuals.items.qlcv")) */
  titleKey: string;
  /** Filename inside public/manuals/ */
  file: string;
}

/**
 * Registry of available user manuals.
 * Each entry maps to an HTML file in public/manuals/.
 * Gated by individual feature flags.
 */
export const MANUALS: ManualEntry[] = [
  ...(ENV.USER_MANUAL_ENABLED
    ? [
        { slug: "qlcv", titleKey: "qlcv", file: "qlcv.html" },
        { slug: "hrm", titleKey: "hrm", file: "hrm.html" },
      ]
    : []),
  ...(ENV.FIELD_DEFINITIONS_ENABLED
    ? [
        {
          slug: "field-definitions",
          titleKey: "fieldDefinitions",
          file: "field-definitions.html",
        },
      ]
    : []),
];
